const initialState = {
  base64: null,
};

export default function workCredentialReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_WORK_CREDENTIAL':
      return { ...state, base64: action.payload };
    case 'CLEAR_WORK_CREDENTIAL':
      return { ...state, base64: null };
    default:
      return state;
  }
}
